/**
 *
 * WheelchairTag
 *
 */

import React, { memo } from 'react';
import styled from 'styled-components';

import ConditionsIcon from 'assets/v2/ConditionsIcon';
import { COLORS } from 'theme';
import Tag from '..';

const StyledTag = styled(Tag)`
  &.MuiChip-root {
    color: ${COLORS.crayolaDark};
    background: ${COLORS.crayolaLight};
    border-color: ${COLORS.crayola};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};

    &&& .MuiChip-icon path {
      fill: ${COLORS.crayola};
    }
  }
`;

function WheelchairTag(props) {
  return <StyledTag label="Wheelchair" icon={<ConditionsIcon />} {...props} />;
}

export default memo(WheelchairTag);
